// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1PW1-","cell":"ColumnAccessor_cell__2HsbR","firstCellAccent":"ColumnAccessor_firstCellAccent__1B7jv"};